import React from 'react'
import { Button } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import NextYear from '@material-ui/icons/FastForward'
import PrevYear from '@material-ui/icons/FastRewind'
import NextWeek from '@material-ui/icons/ArrowRight'
import PrevWeek from '@material-ui/icons/ArrowLeft'
import messages from 'routes/App/Dashboard/translate'

function DashboardSchema(props) {
  const {
    toggleClasses,
    currentWeek,
    currentYear,
    currentMonth,
    isDisablePrevYear,
    isDisableNextYear,
    isDisablePrevWeek,
    isDisableNextWeek,
    prevWeek,
    nextWeek,
    prevYear,
    nextYear,
    onChronologyNavigate,
  } = props

  return (
    <div className={`filter-weeks ${toggleClasses}`}>
      <div className="filter-left week-nav">
        <Button
          href={null}
          variant="contained"
          data-nav="prev"
          data-nav-step="years"
          className="filter-button prev-year"
          disabled={isDisablePrevYear}
          onClick={onChronologyNavigate}>
          <PrevYear className="icon" />
          <span className="btn-text">{prevYear()}</span>
        </Button>
        <Button
          href={null}
          variant="contained"
          data-nav="prev"
          data-nav-step="weeks"
          className="filter-button prev-week"
          disabled={isDisablePrevWeek}
          onClick={onChronologyNavigate}>
          <PrevWeek className="icon" />
          <span className="btn-text">
            <FormattedMessage {...messages.filterWeek} />{' '}
            {prevWeek(currentWeek)}
          </span>
        </Button>
      </div>
      <div className="current-info">
        <div className="current-week">
          <FormattedMessage {...messages.filterWeek} /> {currentWeek}
        </div>
        <div className="current-year">{`${currentMonth} ${currentYear}`}</div>
      </div>
      <div className="filter-right week-nav">
        <Button
          href={null}
          variant="contained"
          data-nav="next"
          data-nav-step="weeks"
          className="filter-button next-week"
          disabled={isDisableNextWeek}
          onClick={onChronologyNavigate}>
          <NextWeek className="icon" />
          <span className="btn-text">
            <FormattedMessage {...messages.filterWeek} />{' '}
            {nextWeek(currentWeek)}
          </span>
        </Button>
        <Button
          href={null}
          variant="contained"
          data-nav="next"
          data-nav-step="years"
          className="filter-button next-year"
          disabled={isDisableNextYear}
          onClick={onChronologyNavigate}>
          <NextYear className="icon" />
          <span className="btn-text">{nextYear()}</span>
        </Button>
      </div>
    </div>
  )
}

export default DashboardSchema
